function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 503.497 503.497"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M373.24 17.443c-60.746 0-102.287 29.175-121.492 78.102-19.204-48.926-60.746-78.102-121.492-78.102-130.169 0-173.559 156.203-80.41 259.688 33.063 36.734 193.206 200.079 201.902 208.922 8.695-8.843 168.839-172.188 201.902-208.922 93.149-103.484 49.759-259.688-80.41-259.688",
    style: {
      strokeWidth: 30
    }
  }));
};
export default SvgHeart;